module.exports = __webpack_public_path__ + "static/img/2.f8aa7c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-salud/2.png
// module id = mAof
// module chunks = 0